import getFormData from "Components/Form/Formdata";
import request from "helpers/api_helper";
import { toast } from "react-toastify";

// Get all pages
export const getPages = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `pages${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch pages");
    return error;
  }
};

// Get single page
export const getPage = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `pages/${id}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch page");
    return error;
  }
};

// Create new page
export const createPage = async (data: any, selectedImage? : any) => {
  try {
    let formData = new FormData();
    formData.append('data', JSON.stringify(data));
    if (selectedImage) {
      formData.append('image', selectedImage);
    }
    const token = localStorage.getItem("token");
    const args = {
      url: "pages",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        content: 'multipart/form-data',
      },
      body: formData,
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Page created successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to create page");
    return error;
  }
};

// Update page
export const updatePage = async (id: string, data: any) => {
  try {
    const formData = getFormData(data)
    const token = localStorage.getItem("token");
    const args = {
      url: `pages/${id}`,
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Page updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update page");
    return error;
  }
};

// Delete page
export const deletePage = async (id: number) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `pages/${id}`,
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Page deleted successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to delete page");
    return error;
  }
};

export const getPageTypes = async (queryString?: string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: `page_types${queryString ? `?${queryString}` : ''}`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch pages");
    return error;
  }
};